import A11yDialog from 'a11y-dialog';
import { toggleClass, toggleAttribute } from '../helpers';
/**
 * Open a dialog from the Send Message button on
 * the profile listing sidebar
 */
const init = () => {
	const dialogEls = Array.from(document.querySelectorAll('.dialog'));

	if (dialogEls.length === 0) {
		return;
	}

	dialogEls.forEach((el) => {
		const mainEl = document.getElementById('geodir-wrapper-content');
		const dialog = new A11yDialog(el, mainEl);

		dialog.on('show', (dialogElement) => {
			toggleClass(dialogElement.querySelector('.dialog-overlay'), '-modal-open');
			toggleAttribute(dialogElement.parentElement, 'aria-hidden');
		});

		dialog.on('hide', (dialogElement) => {
			toggleAttribute(dialogElement.parentElement, 'aria-hidden');
		});
	});
};

init();
